const $ = require('cash-dom');
const popup = require('./popup');

let suppressChatPopTimeout = null;

const loadMap = {};
let firstLoaderAdding = true;

function setLoadMap(tag, value, element = null) {
  loadMap[tag] = loadMap[tag] !== undefined ? loadMap[tag] : {};
  loadMap[tag]['value'] = value;
  loadMap[tag]['element'] = element;
}

function getLoadMapValue(tag) {
  return loadMap[tag] ? loadMap[tag]['value'] : undefined;
}

function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

function fixLoaders() {
  $.each(loadMap, function (i, loaderValAndEl) {
    const loader = loaderValAndEl['value']
    const element = loaderValAndEl['element']

    if (loader.hasClass('global-loader') && element) {
      const offset = element.offset();
      if (offset) {
        loader.css({
          top: offset.top - document.documentElement.scrollTop,
          left: offset.left - document.documentElement.scrollLeft,
          right: 'auto',
          bottom: 'auto',
          width: element.outerWidth(),
          height: element.outerHeight()
        });
      }
    }
  });
}

const Page = {
  scrollTo: function (dest, time, offset) {
    setTimeout(function () {
      var $offset = $(dest).offset();
      if ($offset) {
        window.scroll({top: $offset.top + (offset || 0), left: 0, behavior: 'smooth'});
      }
    }, 1);
  },
  getLanguage: function () {
    var matches = $('html').get(0).className.match(/language-(\w{2})/);
    if (matches) {
      return matches[1];
    }

    return false;
  },
  isRTL: function () {
    return hasClass(document.documentElement, 'is-rtl');
  },
  tagIsFree: function (tag) {
    return typeof (getLoadMapValue(tag)) === 'undefined';
  },
  startLoad: function (tag, element) {
    if (element === 'popup') {
      element = '#popup .popup-container';
    }
    element = $(element);
    //console.log('Loading ', tag, '...');
    if (element.is('.action-loader')) {
      setLoadMap(tag, element);
      element.addClass('active');
    } else {
      var offset = element.offset();
      if (offset) {
        setLoadMap(tag, $('<div class="global-loader">&nbsp;</div>').appendTo('body').show(), element);

        if (firstLoaderAdding) {
          firstLoaderAdding = false;
          $(window).on('resize scroll', fixLoaders);
        }

        fixLoaders();
      }
    }
  },
  onHashTag: function (hashTag, callback) {
    $(document).on('click', '[href*="#"]', function (event) {
      var hash = $(this).attr('href').split('#')[1];
      if (!hash) {
        return true;
      }
      if (hashTag instanceof RegExp) {
        var matches = hash.match(hashTag);
        if (matches) {
          event.preventDefault();
          callback.apply(hash, matches.slice(1));
        }
      } else {
        if (hash === hashTag) {
          event.preventDefault();
          callback.call(this);
        }
      }
    });
    $(window).on('load', function () {
      var hash = window.location.href.split('#')[1];
      if (!hash) {
        return true;
      }

      if (hashTag instanceof RegExp) {
        var matches = hash.match(hashTag);
        if (matches) {
          callback.apply(null, matches.slice(1));
        }
      } else {
        if (hash === hashTag) {
          callback.call(null);
        }
      }
    });
  },
  finishLoad: function (tag) {
    //console.log('Finished loading ', tag);
    var element = getLoadMapValue(tag);
    if (element && element.length > 0) {
      if (element.is('.action-loader')) {
        element.removeClass('active');
      } else {
        element.remove();
      }

      delete loadMap[tag];
    }
  },
  load: function (url) {
    document.location = url ? url : document.location;
  },
  inNewTab: function (url) {
    var win = window.open(url, '_blank');
    win.focus();

  },
  isAtPath: function (path) {
    return document.location.pathname === path;
  },
  isSingle: function (slug) {
    return slug ? hasClass(document.body, 'single-' + slug) : hasClass(document.body, 'single');
  },
  isTemplate: function (slug) {
    return slug ? hasClass(document.body, 'page-template-' + slug) : hasClass(document.body, 'page-template');
  },
  isCategory: function (slug) {
    return slug ? hasClass(document.body, 'category-' + slug) : hasClass(document.body, 'category');
  },
  isSSL: function () {
    return document.location.protocol === 'https:';
  },
  closePopups: function () {
    popup.hide();
  },
  suppressChatPop: function (yes) {
    // console.log("suppressChatPop");
    if (yes) {
      //     console.log("yes");
      // TODO where is _trySuppressChatPop?
      // suppressChatPopTimeout = setTimeout(_trySuppressChatPop, 10);
    } else {
      //   console.log("no");
      if (suppressChatPopTimeout) {
        clearTimeout(suppressChatPopTimeout);
        suppressChatPopTimeout = null;
      }
      if (typeof (window['LC_API']) !== 'undefined' && typeof (window['LC_Invite']) !== 'undefined') {
        window['LC_API']['minimize_chat_window']();
      }
    }
  },
  getSearchParameters: function () {
    if (window.location.search.length) {
      var searchArr = window.location.search.substr(1).split('&'),
        result = {};

      searchArr.forEach(function (item) {
        var tmp = item.split('=');
        result[tmp[0]] = decodeURIComponent(tmp[1]);
      });

      return result;
    } else {
      return {};
    }
  },
};

module.exports = Page;
